import { useEffect } from 'react';

const useCSSVariable = function (name, value, scope) {
  let additionalDependencies = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  return useEffect(() => {
    scope === null || scope === void 0 || scope.style.setProperty(name, value !== null && value !== void 0 ? value : null);
  }, [value, name, scope, ...additionalDependencies]);
};

export { useCSSVariable as default };
